/**
 * Modern Bangalore Delivery Location Modal
 * Handles area search, pincode validation, modal open/close,
 * localStorage persistence, header sync, and collection redirect.
 */
function initBengaluruLocationModal() {
  // Curated list of prominent Bangalore delivery hubs & areas
  const bangaloreAreas = [
    { area: "Koramangala", pincode: "560095", keywords: "koramangala 560095 560034 sony world forum 560047" },
    { area: "Indiranagar", pincode: "560038", keywords: "indiranagar 560038 560008 100ft 12th main defense" },
    { area: "HSR Layout", pincode: "560102", keywords: "hsr layout 560102 sector 1 2 3 4 5 6 7 agara" },
    { area: "Whitefield", pincode: "560066", keywords: "whitefield 560066 itpl itpb kadugodi varthur" },
    { area: "Jayanagar", pincode: "560041", keywords: "jayanagar 560041 560011 4th block 9th block south" },
    { area: "Electronic City", pincode: "560100", keywords: "electronic city 560100 ecity phase 1 2 infosys" },
    { area: "Bellandur", pincode: "560103", keywords: "bellandur 560103 ecospace outer ring road green glen" },
    { area: "MG Road / CBD", pincode: "560001", keywords: "mg road brigade road church street cbd 560001 central" },
    { area: "JP Nagar", pincode: "560078", keywords: "jp nagar 560078 phase 1 2 3 4 5 6 7 8 sarakki" },
    { area: "Malleshwaram", pincode: "560003", keywords: "malleshwaram 560003 malleswaram sampige margosa ctr" },
    { area: "Hebbal", pincode: "560024", keywords: "hebbal 560024 manyata tech park flyover kempapura" },
    { area: "Marathahalli", pincode: "560037", keywords: "marathahalli 560037 bridge multiplex outer ring road orr" },
    { area: "BTM Layout", pincode: "560068", keywords: "btm layout 560068 560076 stage 1 2 madiwala tavarekere" },
    { area: "Banashankari", pincode: "560050", keywords: "banashankari 560050 560085 bsk stage 1 2 3 padmanabhanagar" },
    { area: "Sarjapur Road", pincode: "560035", keywords: "sarjapur road 560035 wipro carmelaram doddakannelli" },
    { area: "Rajajinagar", pincode: "560010", keywords: "rajajinagar 560010 orion mall navrang bashyam circle" },
    { area: "Basavanagudi", pincode: "560004", keywords: "basavanagudi 560004 dvg road bull temple gandhi bazaar" },
    { area: "Yelahanka", pincode: "560064", keywords: "yelahanka 560064 new town old town kogilu" },
    { area: "Kalyan Nagar / HRBR", pincode: "560043", keywords: "kalyan nagar 560043 hrbr layout kammanahalli banaswadi" },
    { area: "Mahadevapura", pincode: "560048", keywords: "mahadevapura 560048 hoodi phoenix marketcity vr" },
    { area: "Domlur", pincode: "560071", keywords: "domlur 560071 egl intermediate ring road doopanahalli" },
    { area: "Richmond Town", pincode: "560025", keywords: "richmond town 560025 langford town shanthi nagar" },
    { area: "Ulsoor", pincode: "560008", keywords: "ulsoor 560008 halasuru lake someshwara" },
    { area: "Frazer Town", pincode: "560005", keywords: "frazer town 560005 pulakeshi nagar coles park mosque" },
    { area: "Shivajinagar", pincode: "560051", keywords: "shivajinagar 560051 commercial street russell market" },
    { area: "Vasanth Nagar", pincode: "560052", keywords: "vasanth nagar 560052 mount carmel palace high grounds" },
    { area: "Sadashivanagar", pincode: "560080", keywords: "sadashivanagar 560080 sankey tank palace grounds raman" },
    { area: "RT Nagar", pincode: "560032", keywords: "rt nagar 560032 rabindranath tagore nagar ganganagar" },
    { area: "Sanjaynagar", pincode: "560094", keywords: "sanjaynagar 560094 geddalahalli raddison" },
    { area: "Vidyaranyapura", pincode: "560097", keywords: "vidyaranyapura 560097 bel hmt thindlu" },
    { area: "Yeshwanthpur", pincode: "560022", keywords: "yeshwanthpur 560022 apmc rmc yard railway station" },
    { area: "Vijayanagar", pincode: "560040", keywords: "vijayanagar 560040 rpc layout pipeline chord road" },
    { area: "Nagarbhavi", pincode: "560072", keywords: "nagarbhavi 560072 bangalore university bda complex" },
    { area: "Kengeri", pincode: "560060", keywords: "kengeri 560060 satellite town rv college mysore road" },
    { area: "KR Puram", pincode: "560036", keywords: "kr puram 560036 krishnarajapuram hanging bridge seegehalli" },
    { area: "CV Raman Nagar", pincode: "560093", keywords: "cv raman nagar 560093 kaggadasapura bagmane drdo" },
    { area: "HAL / Airport Road", pincode: "560017", keywords: "hal airport road 560017 murugeshpalya kodihalli old airport" },
    { area: "Bannerghatta Road", pincode: "560076", keywords: "bannerghatta road 560076 arekere meenakshi royal meenakshi" },
    { area: "Uttarahalli", pincode: "560061", keywords: "uttarahalli 560061 subramanyapura channasandra" },
    { area: "Padmanabhanagar", pincode: "560070", keywords: "padmanabhanagar 560070 devegowda circle kadirenahalli" },
    { area: "Bommanahalli", pincode: "560068", keywords: "bommanahalli 560068 hosur road garebhavipalya" },
    { area: "Kammanahalli", pincode: "560084", keywords: "kammanahalli 560084 sena vihar jal vayu vihar nehru road" },
    { area: "Banaswadi", pincode: "560043", keywords: "banaswadi 560043 ombr layout chikka banaswadi" },
    { area: "Hennur", pincode: "560043", keywords: "hennur 560043 hennur road geddalahalli cross" },
    { area: "Horamavu", pincode: "560043", keywords: "horamavu 560043 agara kalkere road" },
    { area: "Ramamurthy Nagar", pincode: "560016", keywords: "ramamurthy nagar 560016 kowdenahalli kalkere" },
    { area: "Hoodi", pincode: "560048", keywords: "hoodi 560048 seetharampalya itpl road" },
    { area: "Wilson Garden", pincode: "560027", keywords: "wilson garden 560027 lakkasandra chinnayanpalya 10th cross" },
    { area: "Austin Town / Neelasandra", pincode: "560047", keywords: "austin town neelasandra 560047 viveknagar" },
    { area: "Seshadripuram", pincode: "560020", keywords: "seshadripuram 560020 kumara park west nehru circle" },
    { area: "Mathikere", pincode: "560054", keywords: "mathikere 560054 ms ramaiah gokula circle" },
    { area: "Jalahalli", pincode: "560013", keywords: "jalahalli 560013 560015 cross east west bel circle" },
    { area: "Peenya Industrial Area", pincode: "560058", keywords: "peenya 560058 industrial estate 1st 2nd 3rd 4th phase" },
    { area: "Dasarahalli", pincode: "560057", keywords: "dasarahalli 560057 t dasarahalli bagalagunte metro" },
    { area: "Chikkabanavara", pincode: "560090", keywords: "chikkabanavara 560090 heseraghatta road sapthagiri" },
    { area: "Jigani", pincode: "560105", keywords: "jigani 560105 industrial area apc circle bommasandra" },
    { area: "Chandapura", pincode: "560099", keywords: "chandapura 560099 suryacity heelalige anekal road" },
    { area: "Attibele", pincode: "562107", keywords: "attibele 562107 toll plaza sarjapur attibele" },
    { area: "Anekal", pincode: "562106", keywords: "anekal 562106 thally road town circle" },
    { area: "Hoskote", pincode: "562114", keywords: "hoskote 562114 pillagumpa industrial bypass" },
    { area: "Nelamangala", pincode: "562123", keywords: "nelamangala 562123 sondekoppa road toll" },
    { area: "Devanahalli", pincode: "562110", keywords: "devanahalli 562110 kia airport bial trumpet" },
    { area: "Bagalur", pincode: "562149", keywords: "bagalur 562149 aerospace park reva university" }
  ];

  const modal = document.getElementById("delivery-modal");
  const globalPincodesRaw = modal ? (modal.dataset.globalPincodes || "") : "";
  const validBangalorePins = new Set();
  
  // Seed with curated areas
  bangaloreAreas.forEach(a => validBangalorePins.add(a.pincode));

  // Seed with theme settings pincodes
  if (globalPincodesRaw) {
    String(globalPincodesRaw).split(/[\s,\r\n]+/).forEach(p => {
      const clean = p.trim();
      if (/^\d{6}$/.test(clean)) validBangalorePins.add(clean);
      else if (/^\d{12}$/.test(clean)) {
        validBangalorePins.add(clean.slice(0, 6));
        validBangalorePins.add(clean.slice(6, 12));
      }
    });
  }

  const closeModalBtns = document.querySelectorAll("#delivery-close-modal, .bengaluru-modal-close, #delivery-bottom-close-btn, [data-close-modal]");
  const deliveryTextPc = document.getElementById("delivery-text-pc");
  const deliveryTextMobile = document.getElementById("delivery-text-mobile");
  const deliveryButtonPc = document.getElementById("delivery-location-pc");
  const deliveryButtonMobile = document.getElementById("delivery-location-mobile");
  const locationInput = document.getElementById("location");
  const clearSearchBtn = document.getElementById("clear-search-btn");
  const matchingResults = document.getElementById("matching-results");
  const noDeliveryMessage = document.getElementById("no-delivery-message");
  const areaChips = document.querySelectorAll(".area-chip");

  let currentSelectedLocation = null;

  const popularBangaloreAreaList = [
    "Koramangala", "Indiranagar", "HSR Layout", "Whitefield", "Jayanagar",
    "Electronic City", "Bellandur", "MG Road / CBD", "MG Road", "JP Nagar",
    "Malleshwaram", "Hebbal", "Marathahalli"
  ];

  function isPopularBangaloreArea(name) {
    if (!name) return false;
    const clean = String(name).trim().toLowerCase();
    return popularBangaloreAreaList.some(p => p.toLowerCase() === clean);
  }

  // Helper: format badge text
  // 1. Popular Bangalore Areas -> Show ONLY Area name (DO NOT show pincode)
  // 2. Another pincode -> Show ONLY Pincode
  function formatDisplayText(locationObj) {
    if (!locationObj) return "Bangalore";
    if (locationObj.selectionType === "popular_area") {
      return locationObj.area || "Bangalore";
    }
    if (locationObj.selectionType === "pincode") {
      return locationObj.pincode || locationObj.area || "Bangalore";
    }
    if (locationObj.area && isPopularBangaloreArea(locationObj.area)) {
      return locationObj.area;
    }
    if (locationObj.pincode) {
      return locationObj.pincode;
    }
    return locationObj.area || "Bangalore";
  }

  // Initialize saved location on load
  function initSavedLocation() {
    let saved = null;
    try {
      saved = JSON.parse(localStorage.getItem("selectedLocation"));
    } catch (e) {}

    const savedPin = localStorage.getItem("pincode");

    if (!saved && savedPin) {
      const found = bangaloreAreas.find(a => a.pincode === savedPin);
      saved = {
        city: "Bangalore",
        pincode: savedPin,
        area: found ? found.area : "",
        selectionType: found && isPopularBangaloreArea(found.area) ? "popular_area" : "pincode"
      };
    }

    if (saved && (saved.pincode || saved.area)) {
      currentSelectedLocation = saved;
      const text = formatDisplayText(saved);
      if (deliveryTextPc) deliveryTextPc.textContent = text;
      if (deliveryTextMobile) deliveryTextMobile.textContent = text;
      highlightActiveChip(saved.pincode);
    } else {
      if (deliveryTextPc) deliveryTextPc.textContent = "Bangalore";
      if (deliveryTextMobile) deliveryTextMobile.textContent = "Bangalore";
    }
  }

  initSavedLocation();

  // Show/Hide Modal with smooth state
  const showModal = () => {
    if (!modal) return;
    modal.style.display = "flex";
    setTimeout(() => modal.classList.add("visible"), 10);
    document.documentElement.classList.add("overflow-hidden", "stopScroll");
    
    const chipsGrid = modal.querySelector(".bengaluru-chips-grid");
    if (chipsGrid) chipsGrid.scrollTop = 0;
    
    if (locationInput) {
      if (currentSelectedLocation && currentSelectedLocation.pincode) {
        locationInput.value = formatDisplayText(currentSelectedLocation);
        if (clearSearchBtn) clearSearchBtn.style.display = "flex";
      } else {
        locationInput.value = "";
        if (clearSearchBtn) clearSearchBtn.style.display = "none";
      }
      setTimeout(() => locationInput.focus(), 80);
    }
    if (matchingResults) matchingResults.style.display = "none";
    if (noDeliveryMessage) noDeliveryMessage.style.display = "none";
  };

  const hideModal = () => {
    if (!modal) return;
    modal.classList.remove("visible");
    setTimeout(() => {
      modal.style.display = "none";
    }, 250);
    document.documentElement.classList.remove("overflow-hidden", "stopScroll");
  };

  // Expose globally so any trigger or sticky header clone can call it
  window.openDeliveryModal = showModal;
  window.closeDeliveryModal = hideModal;

  const handleTriggerKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      showModal();
    }
  };
  if (deliveryButtonPc) {
    deliveryButtonPc.addEventListener("click", showModal);
    deliveryButtonPc.addEventListener("keydown", handleTriggerKey);
  }
  if (deliveryButtonMobile) {
    deliveryButtonMobile.addEventListener("click", showModal);
    deliveryButtonMobile.addEventListener("keydown", handleTriggerKey);
  }
  closeModalBtns.forEach(btn => {
    btn.addEventListener("click", hideModal);
  });

  // Close when clicking overlay backdrop
  modal.addEventListener("click", (e) => {
    if (e.target === modal) hideModal();
  });

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("visible")) {
      hideModal();
    }
  });

  // Highlight area chip
  function highlightActiveChip(pincode) {
    areaChips.forEach(chip => {
      if (pincode && chip.dataset.pincode === pincode) {
        chip.classList.add("selected");
      } else {
        chip.classList.remove("selected");
      }
    });
  }

  // Apply location and automatically redirect
  function applyLocationAndRedirect(area, pincode, selectionType) {
    if (!pincode && !area) return;

    const type = selectionType || (isPopularBangaloreArea(area) ? "popular_area" : (pincode ? "pincode" : "popular_area"));

    const locationObj = {
      city: "Bangalore",
      pincode: pincode || "",
      area: area || "",
      selectionType: type
    };

    currentSelectedLocation = locationObj;

    // Save location to localStorage
    try {
      localStorage.setItem("selectedLocation", JSON.stringify(locationObj));
      if (pincode) localStorage.setItem("pincode", pincode);
    } catch (e) {}

    // Update Header Badges
    const displayText = formatDisplayText(locationObj);
    if (deliveryTextPc) deliveryTextPc.textContent = displayText;
    if (deliveryTextMobile) deliveryTextMobile.textContent = displayText;

    // Update input display
    if (locationInput) {
      locationInput.value = displayText;
    }

    // Highlight active chip
    highlightActiveChip(pincode);

    // If on product page, update product pincode input and trigger validation
    const productPincodeInput = document.getElementById("pincodeInput");
    if (productPincodeInput && pincode) {
      productPincodeInput.value = pincode;
      productPincodeInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    hideModal();

    // Redirect to Bangalore flower delivery collection
    const isFlorahutDomain = window.location.hostname.includes("florahut.com");
    const redirectUrl = isFlorahutDomain 
      ? "https://florahut.com/collections/flower-delivery-in-bangalore"
      : "/collections/flower-delivery-in-bangalore";
    window.location.href = redirectUrl;
  }

  // Area Chip Click Events: Automatically save and redirect (Popular Bangalore Areas -> NO pincode display)
  areaChips.forEach(chip => {
    chip.addEventListener("click", () => {
      const area = chip.dataset.area;
      const pincode = chip.dataset.pincode;
      applyLocationAndRedirect(area, pincode, "popular_area");
    });
  });

  // Clear Search Input Button
  if (clearSearchBtn) {
    clearSearchBtn.addEventListener("click", () => {
      locationInput.value = "";
      clearSearchBtn.style.display = "none";
      matchingResults.style.display = "none";
      noDeliveryMessage.style.display = "none";
      highlightActiveChip(null);
      locationInput.focus();
    });
  }

  // Input Searching
  if (locationInput) {
    locationInput.addEventListener("input", () => {
      const raw = locationInput.value.trim();
      const query = raw.toLowerCase();

      if (clearSearchBtn) {
        clearSearchBtn.style.display = raw.length > 0 ? "flex" : "none";
      }

      matchingResults.innerHTML = "";
      noDeliveryMessage.style.display = "none";

      if (!query) {
        matchingResults.style.display = "none";
        highlightActiveChip(null);
        return;
      }

      // Direct 6-digit Bangalore pincode check (Another Pincode -> Show ONLY Pincode)
      if (/^\d{6}$/.test(query)) {
        if (query.startsWith("560") || query.startsWith("561") || query.startsWith("562") || validBangalorePins.has(query)) {
          const matchedArea = bangaloreAreas.find(a => a.pincode === query);
          const areaName = matchedArea ? matchedArea.area : "";
          applyLocationAndRedirect(areaName, query, "pincode");
          return;
        } else {
          matchingResults.style.display = "none";
          noDeliveryMessage.style.display = "flex";
          return;
        }
      }

      // Search areas list
      const matches = bangaloreAreas.filter(item => {
        return item.area.toLowerCase().includes(query) ||
               item.pincode.startsWith(query) ||
               item.keywords.toLowerCase().includes(query);
      });

      if (matches.length > 0) {
        matchingResults.style.display = "block";
        matches.slice(0, 7).forEach(match => {
          const li = document.createElement("li");
          li.innerHTML = `
            <span class="area-text"><strong>${match.area}</strong>, Bangalore</span>
            <span class="pin-tag">${match.pincode}</span>
          `;
          li.addEventListener("click", () => {
            const isPop = isPopularBangaloreArea(match.area);
            applyLocationAndRedirect(match.area, match.pincode, isPop ? "popular_area" : "pincode");
          });
          matchingResults.appendChild(li);
        });
      } else {
        matchingResults.style.display = "none";
        // If user typed 6 digits that do not belong to Bangalore
        if (query.length >= 5 && /^\d+$/.test(query) && !query.startsWith("560") && !query.startsWith("562") && !query.startsWith("561")) {
          noDeliveryMessage.style.display = "flex";
        }
      }
    });

    locationInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const firstResult = matchingResults.querySelector("li");
        if (firstResult) {
          firstResult.click();
        } else {
          const raw = locationInput.value.trim();
          if (/^\d{6}$/.test(raw) && (raw.startsWith("560") || raw.startsWith("561") || raw.startsWith("562") || validBangalorePins.has(raw))) {
            const matchedArea = bangaloreAreas.find(a => a.pincode === raw);
            const areaName = matchedArea ? matchedArea.area : "";
            applyLocationAndRedirect(areaName, raw, "pincode");
          }
        }
      }
    });
  }
}

// Initialize immediately or on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBengaluruLocationModal);
} else {
  initBengaluruLocationModal();
}

// Global Delegated click listener: guarantees opening modal even on dynamic/sticky headers
document.addEventListener("click", (e) => {
  const trigger = e.target.closest("#delivery-location-pc, #delivery-location-mobile, .delivery-button, .header-delivery-badge");
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof window.openDeliveryModal === "function") {
      window.openDeliveryModal();
    } else {
      const modal = document.getElementById("delivery-modal");
      if (modal) {
        modal.style.display = "flex";
        setTimeout(() => modal.classList.add("visible"), 10);
        document.documentElement.classList.add("overflow-hidden", "stopScroll");
      }
    }
  }
});
